import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "job-type-manage-page" }
const _hoisted_2 = { class: "jtm-header" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "jtm-toolbar" }
const _hoisted_5 = { class: "jtm-check" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "jtm-card" }
const _hoisted_8 = {
  key: 0,
  class: "jtm-empty"
}
const _hoisted_9 = {
  key: 1,
  class: "jtm-empty"
}
const _hoisted_10 = {
  key: 2,
  class: "jtm-table"
}
const _hoisted_11 = { class: "col-sort" }
const _hoisted_12 = { class: "col-name" }
const _hoisted_13 = { class: "col-flag" }
const _hoisted_14 = {
  key: 0,
  class: "jtm-badge jtm-badge--prod"
}
const _hoisted_15 = {
  key: 1,
  class: "jtm-muted"
}
const _hoisted_16 = { class: "col-usage" }
const _hoisted_17 = { class: "col-status" }
const _hoisted_18 = { class: "col-actions" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "jtm-modal" }
const _hoisted_23 = { class: "jtm-modal-title" }
const _hoisted_24 = { class: "jtm-check jtm-check--block" }
const _hoisted_25 = { class: "jtm-modal-actions" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = ["disabled"]

import { onMounted, reactive, ref } from 'vue';
import { jobTypeAdminApi } from '@/services/api';
import { loadJobTypes } from '@/composables/useJobTypes';

interface JobTypeRow {
  cjt_idx: number;
  cjt_name: string;
  cjt_sort: number;
  cjt_is_production: boolean;
  cjt_status: string;
  usageCount?: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'JobTypeManagePage',
  setup(__props) {

const rows = ref<JobTypeRow[]>([]);
const loading = ref(false);
const saving = ref(false);
const showInactive = ref(true);
const dialogOpen = ref(false);
const editing = ref<JobTypeRow | null>(null);
const form = reactive({
  name: '',
  sort: 100,
  isProduction: false,
});

const loadList = async () => {
  loading.value = true;
  try {
    const res = await jobTypeAdminApi.list(showInactive.value);
    rows.value = res.data?.data || [];
  } catch (e: any) {
    alert(e.response?.data?.message || e.message || '목록 조회 실패');
    rows.value = [];
  } finally {
    loading.value = false;
  }
};

const openCreate = () => {
  editing.value = null;
  form.name = '';
  form.sort = (rows.value.filter((r) => r.cjt_status === 'Y').length + 1) * 10;
  form.isProduction = false;
  dialogOpen.value = true;
};

const openEdit = (row: JobTypeRow) => {
  editing.value = row;
  form.name = row.cjt_name;
  form.sort = row.cjt_sort;
  form.isProduction = !!row.cjt_is_production;
  dialogOpen.value = true;
};

const closeDialog = () => {
  if (saving.value) return;
  dialogOpen.value = false;
};

const save = async () => {
  const name = form.name.trim();
  if (!name) {
    alert('직종명을 입력해 주세요.');
    return;
  }
  saving.value = true;
  try {
    if (editing.value) {
      const res = await jobTypeAdminApi.update(editing.value.cjt_idx, {
        name,
        sort: form.sort,
        isProduction: form.isProduction,
      });
      alert(res.data?.message || '수정되었습니다.');
    } else {
      await jobTypeAdminApi.create({
        name,
        sort: form.sort,
        isProduction: form.isProduction,
      });
      alert('등록되었습니다.');
    }
    dialogOpen.value = false;
    await loadList();
    await loadJobTypes(true);
  } catch (e: any) {
    alert(e.response?.data?.message || e.message || '저장 실패');
  } finally {
    saving.value = false;
  }
};

const deactivate = async (row: JobTypeRow) => {
  const usage = row.usageCount || 0;
  const msg = usage
    ? `"${row.cjt_name}"을(를) 비활성화할까요?\n사용 중인 사원 ${usage}명이 있습니다. 기존 데이터는 유지됩니다.`
    : `"${row.cjt_name}"을(를) 비활성화할까요?`;
  if (!confirm(msg)) return;
  saving.value = true;
  try {
    const res = await jobTypeAdminApi.remove(row.cjt_idx);
    alert(res.data?.message || '비활성화했습니다.');
    await loadList();
    await loadJobTypes(true);
  } catch (e: any) {
    alert(e.response?.data?.message || e.message || '비활성화 실패');
  } finally {
    saving.value = false;
  }
};

const reactivate = async (row: JobTypeRow) => {
  saving.value = true;
  try {
    await jobTypeAdminApi.update(row.cjt_idx, { status: 'Y' });
    alert('복구했습니다.');
    await loadList();
    await loadJobTypes(true);
  } catch (e: any) {
    alert(e.response?.data?.message || e.message || '복구 실패');
  } finally {
    saving.value = false;
  }
};

onMounted(() => {
  loadList();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("div", null, [
        _createElementVNode("h2", { class: "jtm-title" }, "직종관리"),
        _createElementVNode("p", { class: "jtm-sub" }, "권한 100 전용 · 카이온 전역 직종 마스터 (인사관리·사원등록 선택 목록)")
      ], -1)),
      _createElementVNode("button", {
        type: "button",
        class: "jtm-btn jtm-btn--primary",
        disabled: saving.value,
        onClick: openCreate
      }, " 직종 추가 ", 8, _hoisted_3)
    ]),
    _createElementVNode("section", _hoisted_4, [
      _createElementVNode("label", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showInactive).value = $event)),
          type: "checkbox",
          onChange: loadList
        }, null, 544), [
          [_vModelCheckbox, showInactive.value]
        ]),
        _cache[5] || (_cache[5] = _createTextVNode(" 비활성 포함 ", -1))
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "jtm-btn jtm-btn--ghost",
        disabled: loading.value,
        onClick: loadList
      }, " 새로고침 ", 8, _hoisted_6)
    ]),
    _createElementVNode("section", _hoisted_7, [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, "불러오는 중…"))
        : (!rows.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, "등록된 직종이 없습니다."))
          : (_openBlock(), _createElementBlock("table", _hoisted_10, [
              _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { class: "col-sort" }, "순서"),
                  _createElementVNode("th", null, "직종명"),
                  _createElementVNode("th", { class: "col-flag" }, "생산직"),
                  _createElementVNode("th", { class: "col-usage" }, "사용"),
                  _createElementVNode("th", { class: "col-status" }, "상태"),
                  _createElementVNode("th", { class: "col-actions" }, "관리")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (row) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: row.cjt_idx,
                    class: _normalizeClass({ inactive: row.cjt_status !== 'Y' })
                  }, [
                    _createElementVNode("td", _hoisted_11, _toDisplayString(row.cjt_sort), 1),
                    _createElementVNode("td", _hoisted_12, _toDisplayString(row.cjt_name), 1),
                    _createElementVNode("td", _hoisted_13, [
                      (row.cjt_is_production)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, "대상"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_15, "—"))
                    ]),
                    _createElementVNode("td", _hoisted_16, _toDisplayString(row.usageCount ?? 0) + "명", 1),
                    _createElementVNode("td", _hoisted_17, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["jtm-badge", row.cjt_status === 'Y' ? 'jtm-badge--on' : 'jtm-badge--off'])
                      }, _toDisplayString(row.cjt_status === 'Y' ? '사용' : '비활성'), 3)
                    ]),
                    _createElementVNode("td", _hoisted_18, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "jtm-link",
                        onClick: ($event: any) => (openEdit(row))
                      }, "수정", 8, _hoisted_19),
                      (row.cjt_status === 'Y')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "jtm-link jtm-link--danger",
                            onClick: ($event: any) => (deactivate(row))
                          }, " 비활성 ", 8, _hoisted_20))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "jtm-link",
                            onClick: ($event: any) => (reactivate(row))
                          }, " 복구 ", 8, _hoisted_21))
                    ])
                  ], 2))
                }), 128))
              ])
            ]))
    ]),
    (dialogOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "jtm-modal-backdrop",
          onClick: _withModifiers(closeDialog, ["self"])
        }, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("h3", _hoisted_23, _toDisplayString(editing.value ? '직종 수정' : '직종 추가'), 1),
            _cache[8] || (_cache[8] = _createElementVNode("label", { class: "jtm-label" }, [
              _createTextVNode("직종명 "),
              _createElementVNode("em", null, "*")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.name) = $event)),
              class: "jtm-input",
              maxlength: "50",
              placeholder: "예: 요양보호사"
            }, null, 512), [
              [_vModelText, form.name]
            ]),
            _cache[9] || (_cache[9] = _createElementVNode("label", { class: "jtm-label" }, "정렬 순서", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.sort) = $event)),
              class: "jtm-input",
              type: "number"
            }, null, 512), [
              [
                _vModelText,
                form.sort,
                void 0,
                { number: true }
              ]
            ]),
            _createElementVNode("label", _hoisted_24, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.isProduction) = $event)),
                type: "checkbox"
              }, null, 512), [
                [_vModelCheckbox, form.isProduction]
              ]),
              _cache[7] || (_cache[7] = _createTextVNode(" 생산직 비과세 대상 직종 ", -1))
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("button", {
                type: "button",
                class: "jtm-btn jtm-btn--ghost",
                disabled: saving.value,
                onClick: closeDialog
              }, "취소", 8, _hoisted_26),
              _createElementVNode("button", {
                type: "button",
                class: "jtm-btn jtm-btn--primary",
                disabled: saving.value || !form.name.trim(),
                onClick: save
              }, _toDisplayString(saving.value ? '저장 중…' : '저장'), 9, _hoisted_27)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})